/* Petrol Post — fixed-slot cart upsells.
 *
 * The Shrine "Product upsells" block caps at 3 products and hides any product
 * already in the cart, so adding one leaves a gap that nothing refills.
 * This keeps SLOTS cards visible across ALL upsell blocks in DOM order, so a
 * slot freed by an add is taken by the next product in line.
 *
 * Add a second Product upsells block (theme editor) to give it a pool to draw
 * from. With only one block of 3 this is a no-op: all 3 stay visible.
 *
 * Sold-out products still render, as a card with a disabled button, so they are
 * skipped here. Otherwise a product that runs out squats a slot showing
 * "Sold out" and the pool never advances past it.
 *
 * Added 2026-08-30.
 */
(function () {
  var SLOTS = 3;
  var HIDE = 'pp-upsell-hidden';

  function injectStyle() {
    if (document.getElementById('pp-upsell-slots-style')) return;
    var s = document.createElement('style');
    s.id = 'pp-upsell-slots-style';
    s.textContent = '.' + HIDE + '{display:none !important}';
    (document.head || document.documentElement).appendChild(s);
  }

  function isSoldOut(card) {
    var btn = card.querySelector('.upsell__add-btn');
    return !!(btn && btn.disabled);
  }

  function apply() {
    var containers = document.querySelectorAll('.cart-drawer-upsells-container');
    if (!containers.length) return;
    var shown = 0;
    for (var i = 0; i < containers.length; i++) {
      var c = containers[i];
      var cards = c.querySelectorAll('cart-drawer-upsell');
      var here = 0;
      for (var j = 0; j < cards.length; j++) {
        if (isSoldOut(cards[j])) {
          cards[j].classList.add(HIDE);
          continue;
        }
        if (shown < SLOTS) {
          cards[j].classList.remove(HIDE);
          shown++;
          here++;
        } else {
          cards[j].classList.add(HIDE);
        }
      }
      // An empty block would otherwise leave its heading and margins behind.
      if (here === 0) {
        c.classList.add(HIDE);
      } else {
        c.classList.remove(HIDE);
      }
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      injectStyle();
      apply();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  // The drawer is replaced wholesale on every cart change, so watch the tree.
  // childList only: the class changes above are attribute writes and cannot
  // re-trigger this observer.
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
